module.exports = __webpack_public_path__ + "img/img5.00818244.jpg";